<template>
  <div
    class="info-table"
    :style="{ 'grid-template-columns': 'minmax(0, 3fr) minmax(0, 1.5fr) minmax(0, 1fr) 44px' }"
  >
    <div class="table-header grey-500 text-sm d-contents">
      <div>{{ $t('File name') }}</div>
      <div>{{ $t('Upload date') }}</div>
      <div>{{ $t('Size') }}</div>
      <div />
    </div>
    <div class="d-contents">
      <FilesTableFile v-for="file in files" :key="file.id" :file="file" />
    </div>
  </div>
</template>

<script>
  import FilesTableFile from '@/containers/tender/tender-info/files-table/FilesTableFile';

  export default {
    name: 'FilesTable',
    components: { FilesTableFile },
    props: {
      files: {
        type: Array,
        required: true,
      },
    },
  };
</script>
